<template>
  <base-dialog :show-close="true" :visible.sync="visible" class="time-select-dialog" width="520px">
    <template v-slot:header>选择日期时间</template>
    <div class="time-info">
      <div class="row">
        <div class="row-title">选择日期时间</div>
        <div class="row-body">
          <div v-if="_.isString(localValue) && valueVarMap[localValue]" class="var-container">
            <span class="var">{{ varLabelMap[localValue] }}</span>
            <div class="icon-close" @click="clearValue">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <normal-select
            :disabled="disabled"
            :select-list="timeTypes"
            :selected-item="timeType"
            @handle-select="selectorTypeChange"
            class="select"
            v-else
          ></normal-select>
          <el-tooltip effect="dark" content="使用工作表的值" placement="top">
            <group-dropdown-menu
              :group-list="dropdownVarList"
              @select="selectVar"
              :disabled="disabled"
            >
              <div class="btn-add buttonSelectTrigger" :class="disabled ? 'btn-disabled' : ''">
                <i class="el-icon-plus"></i>
              </div>
            </group-dropdown-menu>
          </el-tooltip>
        </div>
        <template v-if="timeType == 'Custom'">
          <date-popover
            v-if="['半年度', '季度'].includes(control.timeType) && compareMethod === '等于'"
            :date="localValue"
            :disabled="disabled"
            :placeholder="control.hint"
            @change="changeValue"
            :time-type="control.timeType"
            class="row-body"
          ></date-popover>
          <el-date-picker
            v-else
            v-model="localValue"
            :disabled="disabled"
            :type="dateTimePicker.type"
            placeholder="选择日期时间"
            default-time="00:00:00"
            value-format="yyyy-MM-dd HH:mm:ss"
            :format="dateTimePicker.displayFormat"
            class="row-body"
          ></el-date-picker>
        </template>
      </div>
      <template v-if="timeType == 'NOW'">
        <div class="row">
          <div class="row-title">
            选择运算时的日期格式
            <el-tooltip effect="dark" placement="bottom" content="">
              <div slot="content">
                如：可以将 2019/11/11 12:23 格式化为“日期”，
                <br />
                以 2019/11/11 参与运算。+8h后，得到时间结果：
                <br />
                2019/11/11 8:00。
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <NormalSelect
            :selectList="dateFormat"
            :selectedItem.sync="localValue.format"
            class="row-body"
          ></NormalSelect>
        </div>
        <div class="row">
          <div class="row-title">运算</div>
          <div class="title-tip">
            对所选的运算日期 添加/减去 的时间(添加时间写正数，减去时间写负数)
          </div>

          <el-row :gutter="20" class="mTop10">
            <el-col :span="8" class="column">
              <div class="label">年：</div>
              <el-input v-model="localValue.value.years" size="medium" type="number"></el-input>
            </el-col>
            <el-col :span="8" class="column">
              <div class="label">月：</div>
              <el-input v-model="localValue.value.months" size="medium" type="number"></el-input>
            </el-col>
            <el-col :span="8" class="column">
              <div class="label">日：</div>
              <el-input v-model="localValue.value.days" size="medium" type="number"></el-input>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="mTop10">
            <el-col :span="8" class="column">
              <div class="label">时：</div>
              <el-input v-model="localValue.value.hours" size="medium" type="number"></el-input>
            </el-col>
            <el-col :span="8" class="column">
              <div class="label">分：</div>
              <el-input v-model="localValue.value.minutes" size="medium" type="number"></el-input>
            </el-col>
            <el-col :span="8" class="column">
              <div class="label">秒：</div>
              <el-input v-model="localValue.value.seconds" size="medium" type="number"></el-input>
            </el-col>
          </el-row>
        </div>
        <div class="row">
          <div class="row-title">预览</div>
          <div class="row-body">{{ time }}</div>
        </div>
      </template>
    </div>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import NormalSelect from "@/components/UIComponents/NormalSelect"
import DatePopover from "@/components/BaseComponents/DatePopover"
import { timeTypes, dateFormat, dateKeys } from "@/components/UIComponents/ConditionList/static"
import { timeTypeList } from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"
import BaseDialog from "@/components/UIComponents/BaseDialog"
import BaseButton from "@/components/UIComponents/Button"
import { isValidObjectId } from "@/utils/common"
import GroupDropdownMenu from "@/components/UIComponents/GroupDropdownMenu/GroupDropdownMenu"
import dj from "dayjs"

export default {
  name: "TimeSelectDialog",
  components: { GroupDropdownMenu, BaseButton, BaseDialog, DatePopover, NormalSelect },
  props: {
    control: Object,
    disabled: { type: Boolean, default: false },
    compareMethod: String,
    dropdownVarList: Array,
    varLabelMap: Object
  },
  data() {
    return {
      timeTypes,
      dateFormat,
      timeTypeList,
      dateKeys,
      localValue: null,
      visible: false,
      varItems: []
    }
  },
  computed: {
    valueVarMap() {
      return this._.chain(this.varItems || [])
        .keyBy("value")
        .mapValues("var")
        .value()
    },
    timeType() {
      let result = null
      if (this.localValue) {
        if (typeof this.localValue === "object") {
          result = "NOW"
        } else if (this.varLabelMap[this.localValue]) {
          result = null
        } else {
          result = "Custom"
        }
      } else {
        result = "Custom"
      }
      return result
    },
    time() {
      let result = dj()
      if (this.timeType === "NOW") {
        let djFormat = this.dateFormat.find(item => item.value === this.localValue.format).djFormat
        result = dj(result).format(djFormat)
        this.dateKeys.forEach(item => {
          if (this.localValue.value[item.key]) {
            result =
              this.localValue.value[item.key] > 0
                ? dj(result).add(this.localValue.value[item.key], item.unit)
                : dj(result).subtract(-this.localValue.value[item.key], item.unit)
          }
        })
      }
      return dj(result).format("YYYY-MM-DD HH:mm:ss")
    },
    dateTimePicker() {
      if (!["date", "time"].includes(this.control?._type)) return {}
      if (this.control._type === "date")
        return { type: "date", valueFormat: "yyyy-MM-dd", displayFormat: "yyyy-MM-dd" }
      const timeTypeMap = this._.keyBy(timeTypeList, "value")
      let timeTypeItem = timeTypeMap[this.control.timeType]
      return {
        type: timeTypeItem.controlType,
        valueFormat: timeTypeItem.displayFormat, // value的格式
        djFormat: timeTypeItem.djFormat, // dayjs的格式
        displayFormat: timeTypeItem.displayFormat // 日期输入框实际展示的格式
      }
    }
  },
  methods: {
    open(value) {
      this.localValue = value
      if (!this.timeType) {
        this.varItems = [
          {
            var: true,
            value: this.localValue,
            type: isValidObjectId(this.localValue) ? "FIELD" : "VALUE"
          }
        ]
      }
      this.visible = true
    },
    selectorTypeChange(item) {
      this.localValue = item?.value === "NOW" ? { format: "年月日时分秒", value: {} } : null
    },
    submit() {
      if (this.timeType === "NOW") {
        let valueKeys = this._.keys(this.localValue.value)
        if (valueKeys.length) {
          for (let key of valueKeys) {
            this.localValue.value[key] = Number(this.localValue.value[key])
          }
        }
        this.$emit("input", JSON.stringify(this.localValue))
      } else if (this.timeType === "Custom") {
        this.$emit("input", this.localValue)
      } else {
        this.$emit("input", this.varItems, true)
      }
      this.visible = false
    },
    changeValue(val) {
      this.localValue = val
    },
    clearValue() {
      this.localValue = null
    },
    selectVar(item) {
      this.localValue = item.value
      this.varItems = [
        { var: true, value: item.value, type: isValidObjectId(this.localValue) ? "FIELD" : "VALUE" }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.time-select-dialog {
  .time-info {
    .row {
      font-size: 13px;
      padding-bottom: 15px;
      .row-title {
        font-weight: bold;
        display: flex;
        align-items: center;
      }
      .title-tip {
        font-size: 12px;
        color: #9e9e9e;
        margin-bottom: 8px;
      }
      .row-body {
        margin-top: 10px;
        width: 100%;
        display: flex;
        .var-container {
          display: flex;
          align-items: center;
          height: 32px;
          width: 100%;
          line-height: 28px;
          position: relative;
          padding: 0 10px;
          background: #f8f8f8;
          border: 1px solid #ccc;
          border-radius: 4px 0 0 4px;
          box-sizing: border-box;
          .var {
            padding: 1px 5px;
          }
          .icon-close {
            margin-left: auto;
            font-size: 16px;
            cursor: pointer;
            &:hover {
              color: #1e88e5;
            }
          }
        }
        .select {
          ::v-deep {
            .el-input__inner {
              border-bottom-right-radius: unset;
              border-top-right-radius: unset;
            }
          }
        }
        .btn-disabled {
          background: #f6f7fa;
          cursor: not-allowed;
        }
        .btn-add {
          width: 32px;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-width: 1px 1px 1px 0;
          border-style: solid;
          box-sizing: border-box;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          border-color: #ddd;
          font-size: 20px;
          color: #9e9e9e;
          cursor: pointer;
          &:hover {
            color: #1e88e5;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px 40px;
      color: unset;
    }
  }
}
</style>
